// Dieses Dokument dient jetzt als externe JS-Datei für den Urlaubsmodus (Dawn)
// Dateiname (Empfehlung): assets/vacation-mode.js

(function() {
  // ====== SCHALTER ======
  const vacationEnabled = false; // false = Urlaub AN | false = AUS

  // ====== TEXT ======
  const messageTitle = 'Urlaubspause';
  const messageText  = 'Der Shop ist im Urlaubsmodus. Produkte können angesehen werden, Bestellungen sind vorübergehend deaktiviert.';
  const showOnLoad   = false;  // Popup beim ersten Laden anzeigen

  // ====== OPTIONAL ======
  const alsoShowInlineNote = false; // zusätzlich eine kleine Box oben im Content anzeigen

  // Flag am <html>
  document.documentElement.dataset.vacation = vacationEnabled ? '1' : '0';
  if (!vacationEnabled) return;

  // ---------- Styles (modernes Modal) ----------
  const style = document.createElement('style');
  style.textContent = `
    /* Buttons ausblenden (Dawn + allgemein) */
    html[data-vacation='1'] button[name='add'],
    html[data-vacation='1'] button[type='submit'][name='add'],
    html[data-vacation='1'] form[action^='/cart/add'] button,
    html[data-vacation='1'] .product-form__submit,
    html[data-vacation='1'] .shopify-payment-button,
    html[data-vacation='1'] .shopify-payment-button__button,
    html[data-vacation='1'] .cart__checkout-button,
    html[data-vacation='1'] .drawer__footer button[name='checkout'],
    html[data-vacation='1'] [href='/checkout'],
    html[data-vacation='1'] [href^='/checkout'],
    html[data-vacation='1'] button[name='checkout'],
    html[data-vacation='1'] input[name='checkout'] { display:none !important; }

    /* Optional Inline-Note */
    .vacation-note{display:none;border:1px solid rgba(0,0,0,.12);border-radius:14px;padding:14px 16px;margin:12px 0;background:rgba(0,0,0,.03);font-size:.95rem;line-height:1.35}
    html[data-vacation='1'] .vacation-note{display:block}

    /* Modal */
    .vac-modal-backdrop{position:fixed;inset:0;display:none;align-items:center;justify-content:center;padding:18px;background:rgba(0,0,0,.55);z-index:99999}
    .vac-modal-backdrop.is-open{display:flex}

    .vac-modal{width:min(560px, 100%);background:#fff;border-radius:18px;box-shadow:0 20px 60px rgba(0,0,0,.25);overflow:hidden;transform:translateY(10px);opacity:0;transition:opacity .18s ease, transform .18s ease}
    .vac-modal-backdrop.is-open .vac-modal{transform:translateY(0);opacity:1}

    .vac-modal__header{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;padding:18px 18px 0}
    .vac-modal__title{margin:0;font-size:1.15rem;line-height:1.2}
    .vac-modal__close{appearance:none;border:0;background:transparent;cursor:pointer;border-radius:10px;padding:8px;line-height:0}
    .vac-modal__close:focus{outline:2px solid rgba(0,0,0,.35);outline-offset:2px}

    .vac-modal__body{padding:10px 18px 18px;font-size:1rem;line-height:1.45;color:rgba(0,0,0,.78)}

    .vac-modal__footer{display:flex;gap:10px;justify-content:flex-end;padding:0 18px 18px}
    .vac-modal__btn{appearance:none;border:1px solid rgba(0,0,0,.15);background:#fff;border-radius:12px;padding:10px 14px;cursor:pointer;font-size:.95rem}
    .vac-modal__btn:hover{background:rgba(0,0,0,.03)}

    .vac-modal__btn--primary{border-color:rgba(0,0,0,.18);background:#111;color:#fff}
    .vac-modal__btn--primary:hover{background:#000}

    @media (prefers-reduced-motion: reduce){
      .vac-modal{transition:none}
    }
  `;
  document.head.appendChild(style);

  // ---------- Modal DOM ----------
  const backdrop = document.createElement('div');
  backdrop.className = 'vac-modal-backdrop';
  backdrop.setAttribute('role', 'dialog');
  backdrop.setAttribute('aria-modal', 'true');
  backdrop.setAttribute('aria-labelledby', 'vacModalTitle');

  backdrop.innerHTML = `
    <div class="vac-modal" role="document">
      <div class="vac-modal__header">
        <h2 class="vac-modal__title" id="vacModalTitle"></h2>
        <button class="vac-modal__close" type="button" aria-label="Schließen">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      <div class="vac-modal__body" id="vacModalBody"></div>
      <div class="vac-modal__footer">
        <button class="vac-modal__btn" type="button" data-vac-close>OK</button>
      </div>
    </div>
  `;

  document.body.appendChild(backdrop);

  const titleEl = backdrop.querySelector('#vacModalTitle');
  const bodyEl  = backdrop.querySelector('#vacModalBody');
  const closeBtn = backdrop.querySelector('.vac-modal__close');
  const okBtn = backdrop.querySelector('[data-vac-close]');

  titleEl.textContent = messageTitle;
  bodyEl.textContent  = messageText;

  let lastActiveEl = null;

  function openModal() {
    if (backdrop.classList.contains('is-open')) return;
    lastActiveEl = document.activeElement;
    backdrop.classList.add('is-open');
    closeBtn.focus();
  }

  function closeModal() {
    backdrop.classList.remove('is-open');
    if (lastActiveEl && typeof lastActiveEl.focus === 'function') lastActiveEl.focus();
  }

  // Klick auf Hintergrund schließt
  backdrop.addEventListener('click', (e) => {
    if (e.target === backdrop) closeModal();
  });

  // Buttons
  closeBtn.addEventListener('click', closeModal);
  okBtn.addEventListener('click', closeModal);

  // ESC + minimaler Fokus-Fang
  document.addEventListener('keydown', (e) => {
    if (!backdrop.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeModal();

    if (e.key === 'Tab') {
      const focusables = backdrop.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      const list = Array.from(focusables).filter(el => !el.hasAttribute('disabled'));
      if (!list.length) return;
      const first = list[0];
      const last = list[list.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  // ---------- Optional Inline-Hinweis ----------
  if (alsoShowInlineNote) {
    const note = document.createElement('div');
    note.className = 'vacation-note';
    note.innerHTML = '<strong>' + messageTitle + '</strong><br>' + messageText;
    const host = document.querySelector('main, #MainContent, [role="main"], .page-width') || document.body;
    host.prepend(note);
  }

  // ---------- Blocker: statt alert -> Modal ----------
  function blockAction(e) {
    e.preventDefault();
    e.stopPropagation();
    openModal();
  }

  // Form-Submits abfangen
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form) return;

    if (form.action && form.action.includes('/cart/add')) return blockAction(e);
    if ((form.action || '').includes('/cart') && form.querySelector('[name="checkout"]')) return blockAction(e);
  }, true);

  // Klicks abfangen (Buy now / Shop Pay / Checkout Links)
  document.addEventListener('click', function(e) {
    const el = e.target.closest('button, a, input');
    if (!el) return;

    const blocked = [
      'button[name="add"]',
      'button[name="checkout"]',
      'input[name="checkout"]',
      '.shopify-payment-button',
      '.shopify-payment-button__button',
      '[href^="/checkout"]'
    ];

    if (blocked.some(s => el.matches(s) || el.closest(s))) return blockAction(e);
  }, true);

  // Direkt /checkout aufgerufen?
  if (location.pathname.startsWith('/checkout')) {
    location.href = '/cart';
  }

  // Popup beim Laden
  if (showOnLoad) {
    // einmal pro Session (damit es nicht bei jedem Klick nervt)
    const key = 'vacation_modal_seen';
    if (!sessionStorage.getItem(key)) {
      sessionStorage.setItem(key, '1');
      window.requestAnimationFrame(openModal);
    }
  }
})();
